import React, { type PropsWithChildren } from 'react';

import { IntlProvider } from 'react-intl-next';

import { Box, xcss } from '@atlaskit/primitives';

import { ModalMode } from '../../common/utils/analytics/types';

import { ModalHeader } from './header';

type Props = PropsWithChildren<{
	mode: ModalMode;
	title: string;
	analyticsSource: string;
	onClose: () => void;
	onModeChange: (mode: ModalMode) => void;
	onPrevModeChange?: () => void;
}>;

export const ModalContent = ({
	mode,
	title,
	analyticsSource,
	children,
	onClose,
	onModeChange,
	onPrevModeChange,
}: Props) => (
	<IntlProvider locale="en">
		<Box xcss={outerBoxStyles}>
			<ModalHeader
				title={title}
				mode={mode}
				analyticsSource={analyticsSource}
				onClose={onClose}
				onModeChange={onModeChange}
				onPrevModeChange={onPrevModeChange}
			/>
			{mode !== ModalMode.DOCKED && (
				<>
					<Box xcss={modalBodyStyles}>{children}</Box>
				</>
			)}
		</Box>
	</IntlProvider>
);

const modalBodyStyles = xcss({
	flex: '1 1 auto',
});

const outerBoxStyles = xcss({
	borderRadius: '3px',
	overflow: 'hidden',
	display: 'flex',
	flexDirection: 'column',
	height: '100%',
});
